<template>
    <div>
        <!-- stage three of post aNewItem -->
        <div class="container">
            <div class="row my-3">
                <div class="col-4">
                    <div class="progress">
                        <div @click="gotoStage1" class="progress-bar bg-dark-green" role="progessbar" style="width: 100%; cursor: pointer;">1/3</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="progress">
                        <div @click="gotoStage2" class="progress-bar bg-dark-green" role="progessbar" style="width: 100%; cursor: pointer;">2/3</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="progress">
                        <div class="progress-bar bg-dark-green" role="progessbar" style="width: 100%;">3/3</div>
                    </div>
                </div>
            </div>
            <!-- Alert Messages -->
            <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                <dd class="col-12">
                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                </dd>
            </dl>
            <form v-if="user">
                <!-- stage heading -->
                <div class="row mt-5">
                    <div class="col-md-7 col-sm-6 col-12">
                        <h3>Item Price</h3>
                    </div>
                    <div class="col-md-5 col-sm-6 col-12">
                        <div class="row">
                            <div class="col-6">
                                <span @click="gotoStage2" class="btn btn-light btn-sm h3 mx-2 form-control">&lt;&lt; Previous</span>
                            </div>
                            <div class="col-6">
                                <button @click.prevent="gotoReviewPost" class="btn btn-dark-green btn-sm h3 form-control">Next &gt;&gt;</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- price window -->
                <div class="row my-3">
                    <div class="col-12">
                        <div class="jumbotron text-center">
                            <h4 class="text-muted small-text">How much do you want to sell this item?</h4>
                            <div class="row my-3">
                                <div class="offset-lg-4 col-lg-4 offset-md-3 col-md-6 col-12">
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text bg-light text-dark-green text-uppercase font-weight-bold">
                                                {{user.currency}}
                                            </div>
                                        </div>
                                        <input type="number" v-model="price" placeholder="enter your price" min="0" class="text-center form-control bg-white no-lines">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="note" class="mx-2">
                                    <span id="note">This item is: </span>
                                </label>
                                <label for="negotiable" class="mx-2">
                                    <input v-model="priceType" type="radio" name="priceTypeRadio" id="negotiable" value="negotiable">  Negotiable
                                </label> 
                                <label for="nonNegotiable" class="mx-2">
                                    <input v-model="priceType" type="radio" name="priceTypeRadio" id="nonNegotiable" value="non-negotiable"> Non-Negotiable
                                </label>
                                <label for="forDonation" class="mx-2">
                                    <input v-model="priceType" type="radio" name="priceTypeRadio" id="forDonation" value="donation"> For Donation (free)
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    name: "StageThree",
    data() {
        return {
            price: '',
            priceType: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['buildNewItemObj']),
        gotoStage1() {
            this.mutateNextStage = true;
            eventBus.gotoStage1(this.mutateNextStage)
        },
        gotoStage2() {
            this.mutateNextStage = true;
            eventBus.gotoStage2(this.mutateNextStage)
        },
        gotoReviewPost() {
            this.color = "danger"
            if(this.price === ''){ this.msg = "Enter item price even if it's to be donated, also remove comma sign if any!"; return }
            if(this.priceType === ''){ this.msg = "Specify if this item is negotiable, non-negotiable or for donation"; return }
            // add properties to build aNewItem object 
            let newItemObj = {
                price: this.price,
                priceType: this.priceType
            }
            // check the price type negotiable, non-negotiable and for donation and process accordingly
            if(this.priceType === "donation"){ 
                newItemObj.firmPrice = true 
                newItemObj.donation = true 
            }
            else if(this.priceType === "negotiable"){ 
                newItemObj.firmPrice = false
                newItemObj.donation = false 
            }
            else {
                newItemObj.firmPrice = true
                newItemObj.donation = false 
            }

            this.buildNewItemObj(newItemObj)
            .then(() => {
                this.mutateNextStage = true;
                eventBus.gotoReviewPost(this.mutateNextStage)
            })
            .catch((e) => {
                this.msg = "We are unable to proceed with this item at this time, do try again."
            })
        }
    },
    computed: {
        ...mapGetters(['user', 'anewitem']),
    },
    created() {
        if(this.anewitem && this.anewitem !== null){
            if(this.anewitem.price){ this.price = this.anewitem.price }
            if(this.anewitem.price === 0){ this.price = 0 }
            if(this.anewitem.priceType){ this.priceType = this.anewitem.priceType }
        }
    }
}
</script>